import { render, staticRenderFns } from "./MedRecordUpdateValueTextType.vue?vue&type=template&id=99916d50"
import script from "./MedRecordUpdateValueTextType.vue?vue&type=script&lang=js"
export * from "./MedRecordUpdateValueTextType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports